import { fetchData } from "@client";

export async function getStackTypeQuery() {
  try {
    const res = await fetchData("/team/stack-type");
    return res.results;
  } catch (e) {
    return [];
  }
}
